import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import {
  Box,
  CircularProgress,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tab,
} from "@mui/material";

import General from "../../stores/GeneralStore";
import User from "../../stores/UserStore";
import moveInOutStore from "../../stores/MoveInOutStore";
import { MoveInHeader, MiniNav } from "../MoveIn.screen/MoveIn.styled";
import { ComplaintContainer } from "../complaint/Complaint.styled";
import { ButtonSecondary } from "../login.screen/login.styled";
import { NotifyError } from "../../utils/ShowError";
import { TabPanel } from "../MoveInRegistration/MoveInRegistration";
import { TabWithCount } from "../SocialCase/SocialCase";
import { a11yProps } from "../Tabs.MUI/Tabs.interface";
import DisputeFees from "../../components/MoveoutDispute/DisputeFees";
import CardsPopup from "../../components/MoveOutTerminationTabs/CardsPopup";
import { platform } from "os";
import { ACTIVE_PAYMENT_GATEWAY } from "../../utils/constants";
import { GatewaySelection } from "../../components/MoveOutTerminationTabs/GatewaySelection";
import { Modal } from "@mui/material";
import { AnyPtrRecord } from "dns";
import CardsStore from "../../stores/CardsStore";
import nocsRequestsStore from "../../stores/NocsRequestsStore";

interface AppConfig {
  "isCheckout" : boolean
}

interface DisputeDuesData {
  currentBalance: string;
  estimatedAmount: string;
  estimatedBillId: string;
  nocFees: string;
  otherDue: string;
  ownerAccountBalance: string;
  ownerDue: string;
  payOffBalance: string;
  paymentAmount: string;
  status: string;
  statusMessage: string;
  transactionRefId: string;
  valueAddedTax: string;
}

const MoveoutDisputeDues: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const [dues, setDues] = useState<Partial<DisputeDuesData>>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [paymentLoader, setPaymentLoader] = useState(false);

  const [value, setValue] = useState(0);
  const contrast = General?.contrast;
  const ColorAss = General?.ColorAss;

  const isCheckoutActive = ACTIVE_PAYMENT_GATEWAY === 'CHECKOUT';
  const currentLAn = General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode === "ARA" ? 'ar' : General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode === "HIN" ? "hi" : 'en'
  const [paymentModal, setPaymentModal] = useState(true);
  
   const [config, setConfig] = useState<AppConfig | null>(null);
  
      useEffect(() => {
          async function loadConfig() {
            try {
              const response = await fetch('/config/config.json'); 
              const json = await response.json();
              setConfig(json);
            } catch (err) {
              console.error("Error loading config:", err);
            }
          }
          loadConfig();
        }, []);

  useEffect(() => {
    const fetchDues = async () => {
      if (!id) {
        NotifyError("No dispute ID provided.");
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        const result = await moveInOutStore.getDisputeDues({
          errorId: "FetchDuesError",
          data: id,
        });

        if (result) {
          setDues(result);
        } else {
          setDues({});
        }
      } catch (error) {
        console.error("Error fetching dispute dues:", error);
        NotifyError("Failed to fetch dispute dues. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchDues();
  }, [id]);
  const handleGetCardsList = async () => {
  await CardsStore.getCardsList({ errorId: "getCardsListError" });
  };
   useEffect(() => {
    handleGetCardsList();
   },[])

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const paymentDataForGateway = {
      platform:"Web",
      personId: User?.info?.personId || 0,
      caseId: id || "",
      transactionRefId: dues?.transactionRefId || "",
      estimatedBillId: dues?.estimatedBillId || "",
      returnUrl: `${window.location.origin}/Payment/ExternalRedirect`, 
      token: '',
      paymentRequestType: 1,
      type:`${currentLAn}-Payments-Web`,
   
  }
  const handlePaymentInitiation = async (payload: any, gatewayType: string) => {
    if(gatewayType === 'ni'){
 const res = await moveInOutStore.NIrentalDisputePayment({
      errorId: "PaymentError",
      data: payload,
    });

    if (res?.message === "Success") {
      return res; 
    } else {
      throw new Error(res?.message || "Payment failed. Please try again");
    }
    }
    if(gatewayType === 'tabby'){
      let eligibledata = {amount:dues?.paymentAmount} as any           
            eligibledata = {
              ...eligibledata,
              mobile : payload.mobile,
              email : payload.emailAddress,
            
          }  
          const eligibilityResponse = await moveInOutStore.makeTabbyEligibilityCheck({
            errorId: "tabbyEligibilityCheckError",
            data: eligibledata,
        });
        if (!eligibilityResponse?.result?.isEligible) {
            throw new Error(eligibilityResponse?.result?.message || "Tabby payment is currently not eligible.");
        }

      const res = await moveInOutStore.TabbyrentalDisputePayment({
      errorId: "PaymentError",
      data: payload,
    });

    if (res?.message === "Success") {
      return res; 
    } else {
      throw new Error(res?.message || "Payment failed. Please try again");
    }
    }
     if(gatewayType === 'tamara'){   
      payload = {
        ...payload,
         mobile : payload.mobile,
        emailAddress : payload.email,
      } 
    const res = await  moveInOutStore.TamararentalDisputePayment({
      errorId: "PaymentError",
      data: payload,
    });

    if (res?.message === "Success") {
      return res; 
    } else {
      throw new Error(res?.message || "Payment failed. Please try again");
    }
  }
}
const checkTabbyEligibility = async (payload: any) => {
  try {
    const response = await moveInOutStore.makeTabbyEligibilityCheck({
            errorId: "tabbyEligibilityCheckError",
            data: payload,
          });
    // return !!response?.result?.isEligible;
    const isEligible = !!response?.result?.isEligible;
    const message = response?.result?.message || "";

   const isAmountEligible = response?.result?.isAmountEligible;

    return { isEligible, message, isAmountEligible };
  } catch (error) {
    console.error("Eligibility check failed:", error);
    return false;
  }
};

const checkTamaraEligibility = async (payload: any) => {
  try {
    const response = await nocsRequestsStore.makeTamaraEligibilityCheck({
            errorId: "tamaraEligibilityCheckError",
            data: payload,
          });
    const message = response?.result?.message || "";
const isAmountEligible = response?.result?.isAmountEligible;

    return {message, isAmountEligible };
  } catch (error) {
    console.error("Tamara eligibility check failed:", error);
    return false;
  }
};

  const handlePayment = async (cardData: any) => {
    setPaymentLoader(true)
    const data = {
      ...cardData,
      platform:"Web",
      emailAddress :cardData?.email,
      personId: User?.info?.personId || 0,
      // paymentAmount: dues?.paymentAmount || 0,
      caseId: id || "",
      transactionRefId: dues?.transactionRefId || "",
      cvv: cardData?.cvv || "",
      estimatedBillId: dues?.estimatedBillId || "",
      
    };
    console.log("Payment data:", data);
    try {
      const res = await moveInOutStore.rentalDisputePayment({
        errorId:"PaymentError",
        data: data,
      });
      console.log("Payment response:", res);
      if (res) {
        console.log("Payment successful:", res);
        window.open(res?.redirectUrl, '_self')
      }
      // if(res){
      //   window.location.href = res?.redirectUrl;
      // }
    } catch (error) {
      console.error("Payment error:", error);
      NotifyError("Payment failed. Please try again.");
    } finally {
      setPaymentLoader(false);
    }
  };
  useEffect(() => {
    console.log("Dues updated:", dues);
  }, [dues]);

  const proceedtoPayment = () => {
    if(dues?.paymentAmount && parseFloat(dues?.paymentAmount) > 0){
      setValue(1)
    }else{
      NotifyError(General?.codeLabels["cm_no_dues_payment"]?.label || "No dues available for payment.");
    }

  }

  return (
    <>
      <MoveInHeader
        style={{
          color: contrast?.contrastColor || "#fff",
          background:
            contrast?.contrastBackground ||
            (ColorAss === "#101E8E" ? "#62aa51" : ColorAss),
        }}
      >
        <div>
          <MiniNav>
            <ButtonSecondary
                style={{
                    width: "81px",
                    height: "30px",
                    border: "1px solid #FFF",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    zIndex: "0",
                    color: contrast?.contrastBackground
                        ? contrast?.contrastBackground
                        : "#fff",
                    background: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "rgba(98, 170, 81, 1)",
                }}
                onClick={() =>
                    User?.info?.personId
                        ? navigate('/dashboard')
                        : navigate('/')
                }
            >
                {General?.codeLabels["cm_back"]?.label || "BACK"}
            </ButtonSecondary>
            {User?.info?.personId && (
              <ButtonSecondary
                style={{
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "#fff",
                  background: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "rgba(98, 170, 81, 1)",
                  width:
                    General?.codeLabels["cm_pdc_paymentaccounts"]
                      ?.languageCode === "ARA"
                      ? "12rem"
                      : "117px",
                  height: "30px",
                  border: "1px solid #FFF",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  zIndex: "0",
                }}
                onClick={() => navigate("/dashboard")}
              >
                {General?.codeLabels["cm_dashboard"]?.label || "DASHBOARD"}
              </ButtonSecondary>
            )}
          </MiniNav>
          <h1
            style={{
              fontFamily: "Segoe UI",
              fontWeight: "400",
              fontSize: General?.isLargeScreen
                ? `${3.1 * General.accessibility.fontSize}rem`
                : `${2 * General.accessibility.fontSize}rem`,
              margin: "0",
            }}
          >
            {General?.codeLabels["cm_dispute_dues"]?.label || "Dispute Dues"}
          </h1>
        </div>
      </MoveInHeader>
      <ComplaintContainer
        style={{
          backgroundColor: contrast?.contrastBackground
            ? contrast?.contrastBackground
            : "#fff",
          width: General?.isLargeScreen ? "" : "100%",
          marginTop: General?.isLargeScreen && value == 3 ? "1rem" : "0rem",
        }}
      >
        <Box
          sx={{
            width: General?.isLargeScreen
              ? `${value == 2 ? "100%" : "80%"}`
              : "100%",
            paddingTop: value == 2 ? "0rem" : "1rem",
          }}
        >
          {value != 2 &&<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              sx={{
                alignSelf: "flex-end",
                width: { md: "70%", lg: "100%" },
                zIndex: "0",
              }}
              variant="scrollable"
              // scrollButtons
              allowScrollButtonsMobile
            >
              <Tab
                label={
                  <TabWithCount value={value} count={1}>
                    <span
                      style={{
                        fontSize: `${0.88 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastBackground
                          : ColorAss,
                      }}
                    >
                      {General?.codeLabels["cm_dues_details"]?.label ||
                        "Dues Details"}
                    </span>
                  </TabWithCount>
                }
                {...a11yProps(0)}
                sx={{
                  background: General?.isLargeScreen
                    ? contrast?.contrastColor
                      ? contrast?.contrastColor
                      : "#e7e9f8"
                    : "",
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "#101e8e",
                  margin: "0.2rem",
                  marginBottom: "0",
                  width: "32.5%",
                  zIndex: "0",
                  alignItems: "start",
                  "&.Mui-selected": {
                    outline: "none",
                  },
                }}
                disabled={true}
              />
              <Tab
                label={
                  <TabWithCount value={value} count={2}>
                    <span
                      style={{
                        fontSize: `${0.88 * General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastBackground
                          : ColorAss,
                      }}
                    >
                      {General?.codeLabels["cm_payment"]?.label || "Payment"}
                    </span>
                  </TabWithCount>
                }
                {...a11yProps(1)}
                sx={{
                  background: General?.isLargeScreen
                    ? contrast?.contrastColor
                      ? contrast?.contrastColor
                      : "#e7e9f8"
                    : "",
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "#101e8e",
                  margin: "0.2rem",
                  marginBottom: "0",
                  width: "32.5%",
                  zIndex: "0",
                  alignItems: "start",
                  "&.Mui-selected": {
                    outline: "none",
                  },
                }}
                disabled={value == 2 ? false : true}
              />
            </Tabs>
          </Box>}
          <TabPanel value={value} index={0}>
            <DisputeFees
              fees={dues}
              loader={loading}
              Previous={() => navigate("/")}
              onClick={proceedtoPayment}
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
            {config?.isCheckout ?( <CardsPopup
              makePayment={handlePayment}
              fromAutoPay={false}
              paymentLoader={paymentLoader}
              amount={dues?.paymentAmount}
              onClose={() => setValue(value - 1)}
              emailForm={true}
            />):(
              <Modal
                open={paymentModal}
                  onClose={(event, reason) => {
                    if (reason === "backdropClick") return;
                    setValue(value - 1);
                  }}
                disableEscapeKeyDown
              >
                <GatewaySelection
                  onClose={() => setValue(value - 1)}
                  paymentData={paymentDataForGateway}
                  handlePayment={handlePaymentInitiation}
                  amount={dues?.paymentAmount}
                  emailForm={true}
                  rentalDues={true}
                  checkTabbyEligibility={checkTabbyEligibility}
                  checkTamaraEligibility={checkTamaraEligibility}

                /></Modal>)}
           
          </TabPanel>
        </Box>
      </ComplaintContainer>
    </>
  );
};

export default observer(MoveoutDisputeDues);
